// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"PrimaryButton-module--primaryButton--2lP7h","disabledPrimaryButton":"PrimaryButton-module--disabledPrimaryButton--3wZbo"};